<template>
  <q-dialog v-model="isInfoModalVisible" persistent>
    <q-card style="width: 300px">
      <q-card-section>
        <div class="text-h6">Info</div>
      </q-card-section>

      <q-card-section class="q-pt-none"> {{ modalText }} </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn flat label="OK" @click="closeModal()" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { computed } from "vue";
import store from "../../store";

const isInfoModalVisible = computed(
  () => store.state.infoModal.infoModalVisible
);
const modalText = computed(() => store.state.infoModal.infoModalText);
const closeModal = () => {
  store.commit("infoModal/closeInfoModal");
};
</script>
<style lang="scss">
.info-popup {
  .popup-content {
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    flex-direction: column;
    width: 100%;

    .large-text {
      font-size: 14px !important;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
